import { LanguageCode } from '@sparted/shared-library/business/types';
import { DeepPartial } from 'ts-essentials';

import { fetchFactory } from 'Libs/http/utils';

import { fromEntityContentMapper } from '../content.mapper';
import type { ContentEntity, ContentFromApi } from '../content.types';

export const updateContent = async (contentId: number, content: DeepPartial<ContentEntity>) => {
  const payload = fromEntityContentMapper(content);

  const { fetchFn } = fetchFactory<ContentFromApi>({
    route: `/api/contents/${contentId}`,
    method: 'PUT',
    payload,
  });
  return fetchFn();
};

export type CreateContentPayload = {
  language: LanguageCode;
  identifier?: string;
  coverImage?: { id: number };
  name: string;
  knowMore?: string;
  thematic: { id: number };
};

export const createContent = async (payload: CreateContentPayload): Promise<{ id: number }> => {
  const { fetchFn } = fetchFactory<{ id: number }>({
    route: '/api/back-office/contents',
    method: 'POST',
    payload,
  });

  return await fetchFn();
};

export const duplicateContent = async (contentId: number, boLanguageCode?: LanguageCode) => {
  const payload = { contentId, boLanguageCode };
  const { fetchFn } = fetchFactory<{ id: number }>({
    route: '/api/contents/duplicate',
    method: 'POST',
    payload,
  });

  return fetchFn();
};

export const getContributors = async () => {
  const { fetchFn } = fetchFactory<{ contributors: { id: number; firstName: string; lastName: string }[] }>({
    route: '/api/contents/contributors',
    method: 'GET',
  });
  return fetchFn();
};

export const fetchContentPreviewUrl = async (contentId: number, languageCode: LanguageCode) => {
  const { fetchFn } = fetchFactory<{ contentPreviewUrl: string }>({
    route: `/api/contents/${contentId}/preview-url`,
    method: 'GET',
    query: {
      language: languageCode,
    },
  });

  return fetchFn();
};
